import uiChainMenu from './chain-menu/index.vue'
import uiChainMenu2 from './chain-menu2'
import uiChainMenu3 from './chain-menu3'

export {
	uiChainMenu,
	uiChainMenu2,
	uiChainMenu3
}

